(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verifytx-schedule', {
                parent: 'entity',
                url: '/verifytx-schedule',
                data: {
                    authorities: [],
                    pageTitle: 'VerifytxSchedules'
                },
                ncyBreadcrumb: {
                    label: 'VerifyTX Schedule'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/verifytx-schedule/list/verifytx-schedule.html',
                        controller: 'VerifytxScheduleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE, access);
                }]
            })
    }

})();
